export const links = [
  {
    title: 'Casino',
    footerLink: [
      {
        text: 'Casino Games',
        url: '',
      },
      {
        text: 'Slots',
        url: '',
      },
      {
        text: 'Live Casino',
        url: '',
      },
      {
        text: 'Roulette',
        url: '',
      },
      {
        text: 'Blackjack',
        url: '',
      },
      {
        text: 'Providers',
        url: '/provider',
      },
      {
        text: 'VIP Club',
        url: '',
      },
      {
        text: 'Promotions',
        url: '',
      },
    ],
  },
  {
    title: 'Support',
    footerLink: [
      {
        text: 'Fairness',
        url: '',
      },
      {
        text: 'Affilliate',
        url: '',
      },
      {
        text: 'Responsible Gambling',
        url: '',
      },
      {
        text: 'Gamble Aware',
        url: '',
      },
      {
        text: 'Live Support',
        url: '',
      },
      {
        text: 'Help Center',
        url: '',
      },
      {
        text: 'How to Guides',
        url: '',
      },
      {
        text: 'Local Currency Guide',
        url: '',
      },
      {
        text: 'Supported Crypto',
        url: '',
      },
    ],
  },
  {
    title: 'Community',
    footerLink: [
      {
        text: 'Blog',
        url: '',
      },
      {
        text: 'Forum',
        url: '',
      },
      {
        text: 'Facebook',
        url: '',
      },
      {
        text: 'Twitter',
        url: '',
      },
      {
        text: 'Instagram',
        url: '',
      },
      {
        text: 'YouTube',
        url: '',
      },
      {
        text: 'Shop',
        url: '',
      },
    ],
  },
  {
    title: 'About us',
    footerLink: [
      {
        text: 'Privacy Policy',
        url: '',
      },
      {
        text: 'Licenses',
        url: '',
      },
      {
        text: 'AML Policy',
        url: '',
      },
      {
        text: 'Terms of Service',
        url: '',
      },
      {
        text: 'Self Exclusion',
        url: '',
      },
      {
        text: 'Primedice',
        url: '',
      },
    ],
  },
]
